module.exports = __webpack_public_path__ + "static/charlie-c9209b09e20c1a14bd8588d2394fec6e.png";